// src/shared/layouts/AppLayoutAuth.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface AppLayoutAuthProps {
  children: React.ReactNode;
}

const AppLayoutAuth: React.FC<AppLayoutAuthProps> = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect if already logged in
    if (localStorage.getItem('token')) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  return <>{children}</>;
};

export default AppLayoutAuth;

